export const animationTiming = {
  glideTime: 1500,
  fadeTime: 1250,
};

export const animationTimingFast = {
  glideTime: 250,
  fadeTime: 250,
};

export const AUD = 'AUD';

export const DEFAULT_CAROUSEL_NUM_ITEMS = 8;
// DIS-1890: the home promotions carousel shows up to 12 promotions, then a "See all" card.
// Product carousels keep DEFAULT_CAROUSEL_NUM_ITEMS.
export const PROMOTIONS_CAROUSEL_NUM_ITEMS = 12;
// DIS-1951: promotion-detail and brand-detail product listings show up to 12 tiles before
// the "See all" card. 12 fills whole rows of the expanded grid (2, 4 and 6 columns).
export const LISTING_CAROUSEL_NUM_ITEMS = 12;
// DIS-1951: lines requested per brand-detail department.
// Assumption: MFL accepts page_size 200 on /shops/:id/lines (the middleware's own lines
// schema caps at 200; MFL's limit is not verified). Assumption: no brand has more than
// 200 lines in one department; brandsStore warns when a department reaches this size.
export const BRAND_DEPARTMENT_PAGE_SIZE = 200;
